const logos = {
	efood: '/images/platform-logos/efood.png',
	wolt: '/images/platform-logos/wolt.png',
	box: '/images/platform-logos/box.png',
	// A private customer's order from the public website's order page.
	website: '/images/platform-logos/website.svg',
};

const titles = {
	website: 'Από το site',
};

export const PlatformLogo = ({ platform }) => {
	if (!logos[platform]) {
		return null;
	}
	return <img src={logos[platform]} className='h-5 w-5' title={titles[platform]} alt={titles[platform] || platform} />;
};
